<div class="close-x" *ngIf="!hasAdditionalActions">
    <button cdkFocusInitial aria-label="Close dialog" (click)="closeClick()">
        <xm-media-image [imageOptions]="imageOptions"></xm-media-image>
    </button>
</div>
<div class="additional-close" *ngIf="hasAdditionalActions">
    <button class="xm-btn-primary-light" *scRichText="field" (click)="closeClick()"></button>
</div>
